import { store } from 'react-notifications-component';

const PopUp = ( value , type , title, message, duration ) => {
    return  value && store.addNotification({
        title,
        message: value.error_message || value.message || message,
        type,
        insert: "right",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        duration,
        dismiss: {
            duration: 10000,
            onScreen: true,
            waitForAnimation: true,
            showIcon: true
        },
        props: {
            className: "error"
        },
        width: 300,
        height: 400
    });
}   


export default PopUp;
